export function cerrarSesion(callback) {
  localStorage.clear();
  sessionStorage.removeItem("modalNotificacionesMostrado");

  document.cookie = "cidi=; max-age=0";
  document.cookie = "token=; max-age=0";
  document.cookie = "refreshToken=; max-age=0";
  document.cookie = "rutaRequisitos=; max-age=0";
  document.cookie = "IsMuni=; max-age=0";

  window.dispatchEvent(
    new CustomEvent("token-localstorage-changed", {
      detail: { storage: null },
    })
  );

  if (typeof callback === "function") {
    callback();
  }
}
